import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaMagento,
  FaCogs,
  FaRocket,
  FaShieldAlt,
  FaChartLine,
  FaTrophy,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MagentoEcommerceDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Magento E-commerce Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Enterprise-Grade E-commerce</Subheading>}
        heading={
          <Heading>
            Magento <span tw="text-primary-500">E-commerce Development</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in Magento e-commerce development
            in **Bur Dubai**, delivering robust, scalable, and feature-rich
            online stores. Harness the power of Magento to elevate your business
            with a customized, high-performance platform.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1577563908411-5077b6dc7624?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build with Magento"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Magento Development in Bur Dubai"
        description="We leverage Magento’s capabilities to deliver exceptional e-commerce solutions."
        cards={[
          {
            icon: <FaMagento color="#ff5464" size={40} />,
            title: "Magento Expertise",
            description: "Certified developers with advanced Magento skills.",
          },
          {
            icon: <FaCogs color="#ff5464" size={40} />,
            title: "Custom Features",
            description:
              "Tailored functionalities to meet your business needs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "High Performance",
            description:
              "Fast, optimized stores for seamless user experiences.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure & Scalable",
            description: "Robust security and scalability for growth.",
          },
          {
            icon: <FaChartLine color="#ff5464" size={40} />,
            title: "Analytics Ready",
            description: "Built-in tools to track and boost performance.",
          },
          {
            icon: <FaTrophy color="#ff5464" size={40} />,
            title: "Proven Success",
            description:
              "Trusted by Bur Dubai businesses for Magento excellence.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Magento Development Process"
        description={
          <Description>
            We build Magento stores with a meticulous, results-driven process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your business and e-commerce goals.</li>
              <li>Design: Create custom, user-friendly Magento themes.</li>
              <li>
                Development: Implement advanced features and integrations.
              </li>
              <li>Testing: Ensure performance, security, and compatibility.</li>
              <li>Launch: Deploy your store with full optimization.</li>
              <li>Support: Provide ongoing maintenance and upgrades.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Magento Success in Bur Dubai"
        description="Our Magento development has transformed businesses locally."
        cards={[
          {
            icon: <FaChartLine color="#ff5464" size={40} />,
            title: "Revenue Growth",
            description: "Increased sales by 200% for a Magento-powered store.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Speed Optimization",
            description: "Improved load times by 50% for better UX.",
          },
          {
            icon: <FaTrophy color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "95% satisfaction from Magento clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Magento Excellence?</Subheading>}
        heading="Your Magento Store in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert Magento e-commerce
            development in Bur Dubai. Build a powerful, scalable online store
            that sets you apart—let’s start today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
